import React, { useState, useEffect } from "react";
import { DataGrid, esES } from "@mui/x-data-grid";
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";
import { useHistory } from "react-router-dom";
import DialogExportar from "./DialogExportar";
import SnackbarAlert from "./SnackbarAlert";
import Grid from "@material-ui/core/Grid";
import SvgIcon from "@material-ui/core/SvgIcon";
import CheckIcon from "@material-ui/icons/Check";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField"; // 👈 Importamos TextField
import useToken from "../useToken";
import InputAdornment from "@mui/material/InputAdornment";

const TablaDiferenciasWalmart = ({
    datos = [],
    totalCount = 0,
    cargando = false,
    page = 0,
    pageSize = 25,
    search = "",
    sortField = "id",
    sortDir = "asc",
    onPageChange,
    onPageSizeChange,
    onSearchChange,
    onSortChange
}) => {
    const history = useHistory();

    const [rows, setRows] = useState([]);
    const [seleccionados, setSeleccionados] = useState([]);
    const [openExportar, setOpenExportar] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);
    const [severity, setSeverity] = useState("");
    const [message, setMessage] = useState("");
    const [reporte, setReporte] = useState("");
    const [params, setParams] = useState("");
    const [cliente, setCliente] = useState(null);

    // Estado local para la escritura rápida en el buscador
    const [inputSearch, setInputSearch] = useState(search);

    useEffect(() => {
        const datosConId = datos.map((row, index) => ({
            ...row,
            id: row.id !== undefined ? row.id : index
        }));
        setRows(datosConId);

        try {
            let datos_inv = useToken.getDatos();
            if (datos_inv && datos_inv.app) {
                setCliente(datos_inv.app);
            }
        } catch (error) {
            console.error("Error al obtener token:", error);
        }
    }, [datos]);

    // ⏱️ DEBOUNCE: Espera 500ms tras pulsar la última tecla antes de lanzar la petición HTTP
    useEffect(() => {
        const timer = setTimeout(() => {
            if (inputSearch !== search) {
                onSearchChange(inputSearch);
            }
        }, 500);
        return () => clearTimeout(timer);
    }, [inputSearch]);

    const verDetalles = (row) => {
        if (row !== null && row.id !== undefined) {
            history.push(`/detalle_diferencia/jerarquia/${row.id}/0/monto`);
        } else {
            history.push("/detalle_diferencia/jerarquia/-1/-1/-1");
        }
    };

    const refrescarExportar = (estado, severityParam) => {
        setOpenSnack(false);
        setSeverity("");
        setMessage("");
        
        if (estado) {
            setOpenExportar(false);
            setOpenSnack(true);
            setMessage(estado);
            setSeverity(severityParam);
        }
    };

    const handleClose = () => {
        setOpenExportar(false);
    };

    const enviarDatosReportes = (nombre) => {
        if (nombre === "variance" || nombre === "variance_walmart" || nombre === "variance_smu") {
            setOpenExportar(true);
            setReporte(nombre);
            setParams(seleccionados);
            setOpenSnack(false);
        } else {
            setOpenExportar(true);
            setReporte(nombre);
            setParams("");
            setOpenSnack(false);
        }
    };

    const numeroFormatoAleman = (valor) => {
        if (valor === undefined || valor === null) return "";
        return new Intl.NumberFormat("de-DE").format(valor);
    };

    const columns = [
        { field: 'descripcion', headerName: 'Descripción', flex: 1, minWidth: 150 },
        { 
            field: 'inv', 
            headerName: 'Inv. cantidad', 
            type: 'number',
            width: 130,
            valueFormatter: ({ value }) => numeroFormatoAleman(value),
        },
        { 
            field: 'teo', 
            headerName: 'Teo. cantidad', 
            type: 'number',
            width: 130,
            valueFormatter: ({ value }) => numeroFormatoAleman(value),
        },
        { 
            field: 'dif', 
            headerName: 'Dif. cantidad', 
            type: 'number',
            width: 130,
            valueFormatter: ({ value }) => numeroFormatoAleman(value),
        },
        { 
            field: 'invimp', 
            headerName: 'Inv. Importe', 
            type: 'number',
            width: 140,
            valueFormatter: ({ value }) => numeroFormatoAleman(value),
        },
        { 
            field: 'teoimp', 
            headerName: 'Teo. Importe', 
            type: 'number',
            width: 140,
            valueFormatter: ({ value }) => numeroFormatoAleman(value),
        },
        { 
            field: 'difimp', 
            headerName: 'Dif. Importe', 
            type: 'number',
            width: 140,
            valueFormatter: ({ value }) => numeroFormatoAleman(value),
        },
        { field: 'registros', headerName: 'Registros', type: 'number', width: 110 },
        { 
            field: 'porcentaje_revisados', 
            headerName: 'Revisados (%)', 
            type: 'number',
            width: 130,
            valueFormatter: ({ value }) => value !== undefined ? (Math.floor(value * 100) / 100).toFixed(1) : "",
        },
        { 
            field: 'en_revision', 
            headerName: 'En revisión', 
            width: 120,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            filterable: false,
            renderCell: (params) => (params.row.porcentaje_revisados > 0 ? <CheckIcon /> : null),
        },
        {
            field: 'acciones',
            headerName: 'Acciones',
            width: 100,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <IconButton 
                    aria-label="ver detalle" 
                    onClick={() => verDetalles(params.row)}
                    color="primary"
                    size="small"
                >
                    <SearchIcon />
                </IconButton>
            )
        }
    ];

    return (
        <div>
            <Grid container direction="row" justifyContent="space-between" alignItems="center" spacing={2} style={{ padding: 10, marginBottom: 10 }}>
                <Grid item xs={12} sm={4}>
                    <TextField
                        placeholder="Buscar por descripción..."
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={inputSearch}
                        onChange={(e) => setInputSearch(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon color="action" />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>

                <Grid item>
                    <Button
                        startIcon={
                            <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                            </SvgIcon>
                        }
                        style={{ margin: 5 }} 
                        disabled={seleccionados.length === 0} 
                        variant="contained" 
                        color="primary" 
                        onClick={() => enviarDatosReportes("variance_walmart")}
                    >
                        Exportar Seleccionado/s
                    </Button>
                    <Button
                        startIcon={
                            <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                            </SvgIcon>
                        }
                        style={{ margin: 5 }} 
                        variant="contained" 
                        color="primary" 
                        onClick={() => enviarDatosReportes("resumen_variance_categoria")}
                    >
                        Resumen por categoría
                    </Button>
                    <Button
                        startIcon={
                            <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                            </SvgIcon>
                        }
                        style={{ margin: 5 }} 
                        variant="contained" 
                        color="primary" 
                        onClick={() => enviarDatosReportes("resumen_variance_subcategoria")}
                    >
                        Resumen por subcategoría
                    </Button>
                </Grid>
            </Grid>

            <div style={{ height: '100%', width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    rowCount={totalCount}
                    loading={cargando}
                    paginationMode="server"
                    paginationModel={{ page: page, pageSize: pageSize }}
                    onPaginationModelChange={(model) => {
                        if (model.page !== page) onPageChange(model.page);
                        if (model.pageSize !== pageSize) onPageSizeChange(model.pageSize);
                    }}
                    pageSizeOptions={[10, 25, 50, 100]}
                    sortingMode="server"
                    sortModel={[{ field: sortField, sort: sortDir }]}
                    onSortModelChange={(sortModel) => {
                        if (sortModel.length > 0) {
                            onSortChange(sortModel[0].field, sortModel[0].sort);
                        }
                    }}

                    disableColumnMenu
                    checkboxSelection
                    disableSelectionOnClick
                    density="compact"
                    localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                    onRowSelectionModelChange={(ids) => {
                        const filasCompletas = ids.map((id) => rows.find((row) => row.id === id)).filter(Boolean);
                        setSeleccionados(filasCompletas);
                    }}
                    sx={{
                        '& .MuiDataGrid-columnHeaderTitleContainer': {
                            flexDirection: 'row !important',
                        },
                        '& .MuiCheckbox-root.Mui-checked, & .MuiCheckbox-root.MuiCheckbox-indeterminate': {
                            color: '#3f51b5',
                        },
                        '& .selected-row-style': { backgroundColor: '#dbe9fc !important' },
                        '& .MuiDataGrid-cell': {
                            fontSize: '15px',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            display: 'flex',
                        },
                    }}
                />
            </div>

            {openExportar && (
                <DialogExportar 
                    reporte={reporte} 
                    origen={'otro'} 
                    params={params} 
                    refrescar={refrescarExportar} 
                    handleClose={handleClose}
                />
            )}
            {openSnack && (
                <SnackbarAlert severity={severity} message={message} />
            )}
        </div>
    );
};

export default TablaDiferenciasWalmart;